export enum InternalRecipientTypesEnum {
  INBOX = 'inbox',
  TEAMMATE = 'teammate',
}
